var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-input',{attrs:{"type":"multi-select","list":_vm.list,"list-value-field":_vm.options.listValueField,"is-animated-dropdown":true},on:{"scroll-end":_vm.handleScrollEnd,"input":_vm.handleInput},model:{value:(_vm.selectedId),callback:function ($$v) {_vm.selectedId=$$v},expression:"selectedId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }